module.exports = __webpack_public_path__ + "static/media/odobreno.44f829bb.svg";